import React, { useState, useEffect } from 'react';
import { Server, Menu, X, ChevronDown } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleDropdownToggle = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <a href="/" className="navbar-logo" onClick={closeMobileMenu}>
          <Server className="logo-icon" />
          <span className="logo-text">HostWare</span>
        </a>

        {/* Desktop Navigation */}
        <ul className="navbar-menu">
          <li className="navbar-item">
            <a href="/" className="navbar-link">
              Accueil
            </a>
          </li>
          
          <li className="navbar-item dropdown">
            <button 
              className="navbar-link dropdown-trigger"
              onClick={() => handleDropdownToggle('services')}
            >
              Services
              <ChevronDown className={`dropdown-icon ${activeDropdown === 'services' ? 'rotated' : ''}`} />
            </button>
            <div className={`dropdown-menu ${activeDropdown === 'services' ? 'active' : ''}`}>
              <a href="/minecraft" className="dropdown-link">Minecraft</a>
              <a href="/novalife" className="dropdown-link">Nova Life : amboise</a>
              <a href="/fivem" className="dropdown-link">FiveM (GTARP)</a>
              <a href="/gmod" className="dropdown-link">Garry's mod</a>
              <a href="/discord" className="dropdown-link">Bot Discord</a>
              <a href="/vps" className="dropdown-link">VPS</a>
            </div>
          </li>

          <li className="navbar-item">
            <a href="/a-propos" className="navbar-link">
              À propos
            </a>
          </li>

          <li className="navbar-item">
            <a href="https://discord.gg/kTbMvkaXYW" className="navbar-link">
              Discord officiel
            </a>
          </li>

          <li className="navbar-item">
            <a href="https://client.hostware.fr/client/support" className="navbar-link">
              Support
            </a>
          </li>
        </ul>

        {/* CTA Buttons */}
        <div className="navbar-cta">
          <a href="https://client.hostware.fr/login" className="btn-login">
            Connexion
          </a>
          <a href="https://client.hostware.fr/register" className="btn-signup">
            Commencer
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? <X className="menu-icon" /> : <Menu className="menu-icon" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-content">
          <a href="/" className="mobile-link" onClick={closeMobileMenu}>
            Accueil
          </a>
          
          <div className="mobile-dropdown">
            <button 
              className="mobile-dropdown-trigger"
              onClick={() => handleDropdownToggle('mobile-services')}
            >
              Services
              <ChevronDown className={`dropdown-icon ${activeDropdown === 'mobile-services' ? 'rotated' : ''}`} />
            </button>
            <div className={`mobile-dropdown-content ${activeDropdown === 'mobile-services' ? 'active' : ''}`}>
              <a href="/minecraft" className="mobile-sub-link" onClick={closeMobileMenu}>Minecraft</a>
              <a href="/novalife" className="mobile-sub-link" onClick={closeMobileMenu}>Nova Life : amboise</a>
              <a href="/fivem" className="mobile-sub-link" onClick={closeMobileMenu}>FiveM (GTARP)</a>
              <a href="/gmod" className="mobile-sub-link" onClick={closeMobileMenu}>Garry's mod</a>
              <a href="/discord" className="mobile-sub-link" onClick={closeMobileMenu}>Bot Discord</a>
              <a href="/vps" className="mobile-sub-link" onClick={closeMobileMenu}>VPS</a>
            </div>
          </div>

          <a href="/a-propos" className="mobile-link" onClick={closeMobileMenu}>
            À propos
          </a>
          <a href="https://discord.gg/tP7M7DAavW" className="mobile-link" onClick={closeMobileMenu}>
            Discord officiel
          </a>
          <a href="https://client.hostware.fr/client/support" className="mobile-link" onClick={closeMobileMenu}>
            Support
          </a>

          <div className="mobile-cta">
            <a href="https://client.hostware.fr/login" className="mobile-btn-login" onClick={closeMobileMenu}>
              Connexion
            </a>
            <a href="https://client.hostware.fr/register" className="mobile-btn-signup" onClick={closeMobileMenu}>
              Commencer
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}
      {isMobileMenuOpen && (
        <button
          className="mobile-menu-close"
          onClick={closeMobileMenu}
          aria-label="Fermer le menu"
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            background: "none",
            border: "none",
            color: "#fff",
            fontSize: "2rem",
            zIndex: 1001,
            cursor: "pointer"
          }}
        >
          ×
        </button>
      )}
    </nav>
  );
};

export default Navbar;